import create from 'zustand';
import api from '../../utils/api';

const initialState = {
  userInfo: '',
  loading: false,
  error: '',
};

const useUsersStore = create((set) => ({
  userInfo: initialState.userInfo,
  loading: initialState.loading,
  error: initialState.error,

  fetchUsers: async () => {
    set((state) => ({ ...state, loading: true }));
    try {
      set((state) => ({ ...state, error: '', userInfo: '' }));
      const userInfoData = await api.call({
        name: 'userInfo',
      });
      if (userInfoData.status === 200) {
        let info = userInfoData.data.data;
        set((state) => ({ ...state, error: '', userInfo: info }));
      }
    } catch (error) {
      set((state) => ({
        ...state,
        error: error.message,
      }));
    } finally {
      set((state) => ({
        ...state,
        loading: false,
      }));
    }
  },

  updateFirstTimeFlag: async () => {
    set((state) => ({ ...state, loading: true }));
    try {
      const response = await api.call({
        name: 'updateFirstTimeFlag',
        data: {
          is_first: 0,
        },
      });

      if (response.status === 200) {
        // Update the local user info with the new is_first value
        set((state) => ({
          ...state,
          userInfo: {
            ...state.userInfo,
            is_first: 0,
          },
        }));
      }
    } catch (error) {
      set((state) => ({
        ...state,
        error: error.message,
      }));
    } finally {
      set((state) => ({
        ...state,
        loading: false,
      }));
    }
  },

  resetUserInfo: () => {
    set((state) => ({
      ...state,
      userInfo: initialState.userInfo,
      loading: initialState.loading,
      error: initialState.error,
    }));
  },
}));

export default useUsersStore;
